import { createSlice } from '@reduxjs/toolkit'
import Config from '../../../Core/Config'

export const SET_SELECTED_VEHICLES = 'frec/ui/vehicles/setSelected'
export const UNSELECT_VEHICLE = 'frec/ui/vehicles/unselect'
export const ACTIVATE_SHORTCUT = 'frec/ui/vehicles/activateShortcut'
export const DISACTIVATE_SHORTCUT = 'frec/ui/vehicles/disactivateShortcut'

const vehiclesUiSlice = createSlice({
  name: 'vehicles',
  initialState: {
    selectedVehicles: [],
    activeShortcut: null,
    menu: {
      expanded: Config.ui.defaultExpandedRightMenu,
    },
  },
  reducers: {
    init: (state) => {
      return { ...state, initing: true }
    },
    setSelectedVehicles: (state, action) => {
      state.selectedVehicles = action.payload
    },
    unselectVehicle: (state, action) => {
      state.selectedVehicles = state.selectedVehicles.filter(
        (v) => v.id !== action.payload.id,
      )
    },
    activateShortcut: (state, action) => {
      state.activeShortcut = action.payload
    },
    disactivateShortcut: (state) => {
      state.activeShortcut = null
    },
    toggleMenuExpanded: (state) => {
      state.menu.expanded = !state.menu.expanded
    },
  },
})

export const {
  setSelectedVehicles,
  unselectVehicle,
  activateShortcut,
  disactivateShortcut,
  toggleMenuExpanded,
} = vehiclesUiSlice.actions
export default vehiclesUiSlice.reducer

export const selectSelectedVehicles = (state) =>
  state.frec.ui.vehicles.selectedVehicles
export const selectActiveShorcut = (state) =>
  state.frec.ui.vehicles.activeShortcut
export const selectMenuExpanded = (state) =>
  state.frec.ui.vehicles.menu.expanded
